import { ɵɵdefineInjectable, Injectable, ɵɵinject, Component, Directive, ViewContainerRef, ViewEncapsulation, Input, ComponentFactoryResolver, ViewChild, Pipe, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { HttpHeaders, HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Subject, of, throwError } from 'rxjs';
import { map, share, first, catchError, tap } from 'rxjs/operators';
import { trigger, transition, query, style, animate } from '@angular/animations';
import { DomSanitizer } from '@angular/platform-browser';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/router';
import * as ɵngcc4 from '@angular/platform-browser';

function LoginInterfaceHeaderComponent_a_20_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 26);
    ɵngcc0.ɵɵlistener("click", function LoginInterfaceHeaderComponent_a_20_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.login(); });
    ɵngcc0.ɵɵtext(1, "Login");
    ɵngcc0.ɵɵelementEnd();
} }
function LoginInterfaceHeaderComponent_a_21_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 26);
    ɵngcc0.ɵɵlistener("click", function LoginInterfaceHeaderComponent_a_21_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.goToMyAccount(); });
    ɵngcc0.ɵɵtext(1, "My Account");
    ɵngcc0.ɵɵelementEnd();
} }
function LoginInterfaceHeaderComponent_a_22_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 27);
    ɵngcc0.ɵɵlistener("click", function LoginInterfaceHeaderComponent_a_22_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.logout(); });
    ɵngcc0.ɵɵtext(1, "Logout");
    ɵngcc0.ɵɵelementEnd();
} }
const _c0 = ["*"];
function LoginHeaderComponent_a_20_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 26);
    ɵngcc0.ɵɵlistener("click", function LoginHeaderComponent_a_20_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.login(); });
    ɵngcc0.ɵɵtext(1, "Login");
    ɵngcc0.ɵɵelementEnd();
} }
function LoginHeaderComponent_a_21_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 26);
    ɵngcc0.ɵɵlistener("click", function LoginHeaderComponent_a_21_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.goToMyAccount(); });
    ɵngcc0.ɵɵtext(1, "My Account");
    ɵngcc0.ɵɵelementEnd();
} }
function LoginHeaderComponent_a_22_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 27);
    ɵngcc0.ɵɵlistener("click", function LoginHeaderComponent_a_22_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.logout(); });
    ɵngcc0.ɵɵtext(1, "Logout");
    ɵngcc0.ɵɵelementEnd();
} }
function LoginHeaderNonBsComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "a", 16);
    ɵngcc0.ɵɵtext(2, "My Account");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "a", 17);
    ɵngcc0.ɵɵlistener("click", function LoginHeaderNonBsComponent_div_17_Template_a_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.logout(); });
    ɵngcc0.ɵɵtext(4, "Logout");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function LoginHeaderNonBsComponent_a_18_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 17);
    ɵngcc0.ɵɵlistener("click", function LoginHeaderNonBsComponent_a_18_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.login(); });
    ɵngcc0.ɵɵtext(1, "Login");
    ɵngcc0.ɵɵelementEnd();
} }
function LoginHeaderFluidComponent_img_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 21);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate1("src", "https://webapps.acep.org/globalstyles/images/", ctx_r0.ORG, "_logo.svg", ɵngcc0.ɵɵsanitizeUrl);
} }
function LoginHeaderFluidComponent_img_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 22);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate1("src", "https://webapps.acep.org/globalstyles/images/", ctx_r1.ORG, "-logo.png", ɵngcc0.ɵɵsanitizeUrl);
} }
function LoginHeaderFluidComponent_a_18_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 23);
    ɵngcc0.ɵɵlistener("click", function LoginHeaderFluidComponent_a_18_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.login(); });
    ɵngcc0.ɵɵtext(1, "Login");
    ɵngcc0.ɵɵelementEnd();
} }
function LoginHeaderFluidComponent_a_19_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 23);
    ɵngcc0.ɵɵlistener("click", function LoginHeaderFluidComponent_a_19_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.goToMyAccount(); });
    ɵngcc0.ɵɵtext(1, "My Account");
    ɵngcc0.ɵɵelementEnd();
} }
function LoginHeaderFluidComponent_a_20_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 24);
    ɵngcc0.ɵɵlistener("click", function LoginHeaderFluidComponent_a_20_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.logout(); });
    ɵngcc0.ɵɵtext(1, "Logout");
    ɵngcc0.ɵɵelementEnd();
} }
const _c1 = [[["", 8, "header-content"]], [["", 8, "side-nav"]], [["", 8, "body-content"]]];
const _c2 = [".header-content", ".side-nav", ".body-content"];
function LayoutOrgMasterComponent_ng_template_0_Template(rf, ctx) { }
class GlobalDomOpsService {
    constructor() {
        this.continueToWait = false;
    }
    CheckValidations(event) {
        try {
            event.preventDefault();
        }
        catch (error) {
        }
        //CHECK VALIDATIONS//
        if (!validator.checkAll($('form'))) {
            this.notify('Incorrect/Missing data found on form.', 'Form Invalid', 'error');
            //scroll to the first error field//
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: $(".validation-error:eq(0)").offset().top
                }, 600);
            }, 100);
            return false;
        }
        return true;
    }
    CheckTemplateDrivenNGValidations(ngform) {
        //event.preventDefault();
        if (ngform.invalid) {
            this.notify('Incorrect/Missing data found on form.', 'Form Invalid', 'error');
            //scroll to the first error field//
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: $(".ng-invalid:eq(0)").offset().top
                }, 600);
            }, 100);
            return false;
        }
        return true;
    }
    CheckNGValidations(ngform) {
        //event.preventDefault();
        if (ngform.invalid) {
            Object.keys(ngform.controls).map((controlName) => {
                ngform.get(controlName).markAsTouched({ onlySelf: true });
            });
            this.notify('Incorrect/Missing data found on form.', 'Form Invalid', 'error');
            //scroll to the first error field//
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: $(".ng-invalid:eq(0)").offset().top
                }, 600);
            }, 100);
            return false;
        }
        return true;
    }
    //LOADERS//
    showwait() {
        $(".loader").show();
    }
    hidewait() {
        $(".loader").hide();
    }
    //checks to see if some other observable is in progress  apploaded
    hideWaitIfNoXHRInProgress() {
        if (!this.continueToWait) {
            this.hidewait();
        }
    }
    //Initialize Jquery Plugins for UI fanciness//
    //LABELAUTY//VALIDATIONS//DATEPICKERS//REMODALS//
    initPlugins(initvalidation = true) {
        let thisSvc = this;
        setTimeout(function () {
            //FLOW LABELS//
            //console.log('Flow labels applied');
            try {
                $('.FlowupLabels').FlowupLabels({
                // options here
                });
            }
            catch (e) {
            }
            //PIKADAY/
            $('.datepicker').pikaday({
                format: 'MM/DD/YYYY',
                minDate: moment('1/1/1900'),
                maxDate: moment('1/1/2100'),
                yearRange: 100
            });
            // //LABELAUTY
            //// $(":radio, :checkbox").not(".nolabelauty").labelauty();
            // $(":radio, :checkbox").not(".nolabelauty").each(function() {
            // $( this ).labelauty();
            // });
            //Breadcrumbs --no way to remove routerlink directly
            $(".inactivelink").each(function () {
                $(this).replaceWith('<a class="inactivelink">' + $(this).text() + '</a>');
            });
            thisSvc.hideWaitIfNoXHRInProgress();
        }, 100);
        //TOASTR
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;
        //NUMERIC ONLY
        $('.numeric').on('keydown', function (e) { -1 !== $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) || /65|67|86|88/.test(e.keyCode) && (!0 === e.ctrlKey || !0 === e.metaKey) || 35 <= e.keyCode && 40 >= e.keyCode || (e.shiftKey || 48 > e.keyCode || 57 < e.keyCode) && (96 > e.keyCode || 105 < e.keyCode) && e.preventDefault(); });
        // > Validate Username field against duplicates and punctuation characters.
        // > Punctuation characters include 
        // > ` , " ' : ; - ! ^ 
        $('.nopunctuationRegex').on('keydown', function (e) {
            switch (e.keyCode) {
                case 8: // Backspace
                case 9: // Tab
                case 13: // Enter
                case 37: // Left
                case 38: // Up
                case 39: // Right
                case 40: // Down
                    break;
                default:
                    var regex = new RegExp("^[a-zA-Z0-9._$@()]+$"); // new RegExp("^[a-zA-Z0-9._/ $@()]+$");
                    var key = e.key;
                    if (!regex.test(key)) {
                        event.preventDefault();
                        return false;
                    }
                    break;
            }
        });
        if (initvalidation) {
            this.initValidationPlugin();
        }
    }
    initValidationPlugin() {
        //VALIDATOR START
        validator.defaults.alerts = false;
        validator.defaults.classes = {
            item: 'validationwrap',
            alert: 'alert',
            bad: 'validation-error'
        };
        $('form')
            .on('blur', 'input[required], input.optional, select.required', validator.checkField)
            .on('change', 'select[required],select.required,:radio,:checkbox', validator.checkField)
            .on('keyup', 'input[required][pattern]', validator.keypress);
        $('.multi.required')
            .on('keyup blur', 'input', function () {
            validator.checkField.apply($(this).siblings().last()[0]);
        });
        // bind the validation to the form submit event
        //$('#send').click('submit');//.prop('disabled', true);
        //$('form').submit(function (e) {
        //    e.preventDefault();
        //    var submit = true;
        //    // Validate the form using generic validaing
        //    if (!validator.checkAll($(this))) {
        //        submit = false;
        //        toastr.error('Incorrect/Missing data found on form.', 'Form Invalid');
        //        return false;
        //    }
        //    else {
        //        return true;
        //    }
        //    //if (submit)
        //    //    this.submit();
        //});
        //VALIDATOR END       
    }
    removeCurrentValidationErrors() {
        validator.unmark($('form'));
    }
    //NOTIFICATION PLUGINS//TOASTR//
    notify(message, title, state) {
        // Immediately remove current toasts without using animation
        toastr.remove();
        if (message) {
            switch (state) {
                case "success":
                    toastr.success(message, title);
                    break;
                case "warning":
                    toastr.warning(message, title);
                    break;
                case "error":
                    toastr.error(message, title);
                    break;
                case "info":
                    toastr.info(message, title);
                    break;
                default:
                    toastr.success(message, title);
                    break;
            }
        }
    }
    IsFormTouched() {
        return ($(".ng-touched").length > 0 || $(".ng-dirty").length > 0);
    }
    scrollToTopOfPage() {
        $("html, body").animate({ scrollTop: 0 }, "fast");
    }
    initStylesForLoginHeader() {
        $(".loginTool").click(function () {
            $(".loginToolopen").slideToggle('fast');
            $(".searchToolopen").hide();
        });
        $(".mSearch").click(function () {
            $(".searchToolopen").slideToggle('fast');
            $(".loginToolopen").hide();
        });
    }
}
GlobalDomOpsService.ɵfac = function GlobalDomOpsService_Factory(t) { return new (t || GlobalDomOpsService)(); };
GlobalDomOpsService.ɵprov = ɵɵdefineInjectable({ factory: function GlobalDomOpsService_Factory() { return new GlobalDomOpsService(); }, token: GlobalDomOpsService, providedIn: "root" });
GlobalDomOpsService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GlobalDomOpsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

// Observable class extensions

class CommonOperationsService {
    constructor() { }
    SantizeDate(date) {
        if (date == "" || date == null)
            return "";
        return moment(date).format('MM/DD/YYYY');
    }
    GetYearSelectRangeWithLimits(pastcount, futurecount) {
        let currentyear = new Date().getFullYear();
        let years = [];
        for (let i = currentyear + futurecount; i > currentyear - pastcount; i--) {
            years.push(i);
        }
        return years;
    }
    /**
     * Returns a deep copy of the object
     * http://stackoverflow.com/questions/36124363/deep-copying-objects-in-angular2
     */
    DeepCopyObject(oldObj) {
        var newObj = oldObj;
        if (oldObj && typeof oldObj === "object") {
            newObj = Object.prototype.toString.call(oldObj) === "[object Array]" ? [] : {};
            for (var i in oldObj) {
                newObj[i] = this.DeepCopyObject(oldObj[i]);
            }
        }
        return newObj;
    }
    getQueryString(name, url) {
        if (!url)
            url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", 'i'), results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        // var results = new RegExp('[\\?&]' + name + '=([^&#]*)', 'i').exec(window.location.href);
        // if(results != null)
        // {
        // }
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
}
CommonOperationsService.ɵfac = function CommonOperationsService_Factory(t) { return new (t || CommonOperationsService)(); };
CommonOperationsService.ɵprov = ɵɵdefineInjectable({ factory: function CommonOperationsService_Factory() { return new CommonOperationsService(); }, token: CommonOperationsService, providedIn: "root" });
CommonOperationsService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CommonOperationsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

var Environment;
(function (Environment) {
    Environment[Environment["DEV"] = 0] = "DEV";
    Environment[Environment["STAGE"] = 1] = "STAGE";
    Environment[Environment["PROD"] = 2] = "PROD";
})(Environment || (Environment = {}));

class GlobalDataOpsService {
    constructor(http, globaldomops, commonops) {
        this.http = http;
        this.globaldomops = globaldomops;
        this.commonops = commonops;
        this.BasePath = this.RefreshBasePath();
        this.WebServicesBasePath = this.RefreshWebServiceBasePath(); //this.isTestEnvironment()? 'https://testws.acep.org' : 'https://ws.acep.org'
        this.ninjaapiendpoint = this.BasePath + "/utils/api/ninja/";
        this.s3endPoint = this.BasePath + "/utils/api/s3/";
        this.ORG = this.GetORG();
        this.loginurl = this.BasePath + "/SAML/sso.ashx?" + "org=" + this.ORG + "&redir=";
        this.logouturl = this.BasePath + "/Logout.aspx";
        this.headers = new HttpHeaders({
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "PUT, GET, POST",
            "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept"
        });
    }
    get CurrentEnv() {
        this.RefreshBasePath();
        return this.Env;
    }
    ///GETS///
    RefreshBasePath() {
        let _basepath = "http://localhost/ACEP";
        this.Env = Environment.DEV;
        if (window.location.href.indexOf("dev") > -1) {
            _basepath = "http://devwebapps.acep.org";
            this.Env = Environment.DEV;
        }
        else if (window.location.href.indexOf("devwebapps") > -1) {
            _basepath = "http://devwebapps.acep.org";
            this.Env = Environment.DEV;
        }
        else if (window.location.href.indexOf("testwebapps.acep.org") > -1) {
            _basepath = "https://testwebapps.acep.org";
            this.Env = Environment.STAGE;
        }
        else if (window.location.href.indexOf("webapps.acep.org") > -1) {
            _basepath = "https://webapps.acep.org";
            this.Env = Environment.PROD;
        }
        return _basepath;
    }
    RefreshWebServiceBasePath() {
        let _basepath = "https://devws.acep.org";
        if (window.location.href.indexOf("dev") > -1) {
            _basepath = "https://devws.acep.org";
        }
        else if (window.location.href.indexOf("devwebapps") > -1) {
            _basepath = "https://devws.acep.org";
        }
        else if (window.location.href.indexOf("testwebapps.acep.org") > -1) {
            _basepath = "https://testws.acep.org";
        }
        else if (window.location.href.indexOf("webapps.acep.org") > -1) {
            _basepath = "https://ws.acep.org";
        }
        return _basepath;
    }
    isTestEnvironment() {
        let url = window.location.href.toLowerCase().replace('https://', '').replace('http://', '');
        let _istest = url.startsWith("testwebapps") || url.startsWith("local") || url.startsWith("devwebapps");
        return _istest;
    }
    GetORG() {
        let _org = this.commonops.getQueryString("org");
        return _org == null ? "ACEP" : _org;
    }
    InjectAnalytics(url) {
        if (!this.isTestEnvironment()) {
            ga("create", "UA-44483360-1", "auto");
            ga("set", "page", url);
            ga("send", "pageview");
        }
    }
    SendEmail(contactid, fromemail, toemail, ccemail, subject, html) {
        let _isTest = this.isTestEnvironment();
        subject = subject + (_isTest ? " - TEST Environment" : "");
        return this.http.post(this.ninjaapiendpoint + "SendEmail", JSON.stringify({
            contactid: contactid,
            fromemail: fromemail,
            toemail: toemail,
            ccemail: ccemail,
            html: html,
            subject: subject
        }), { headers: this.headers, responseType: "text" } // Send response type as text whenever api response is string MB 8/1/2018
        );
        //.map((res: Response) => res.json());
    }
    LogError(contactid, errorContent) {
        return this.http.post(this.ninjaapiendpoint + "LogError", JSON.stringify({ contactid: contactid, error: errorContent }), { headers: this.headers });
        //.map((res: Response) => res.json());
    }
    initThemesBasedOnORG() {
        let url = `${this.BasePath}/globalstyles/css/${this.ORG}.css`;
        //theme link element is in shared-things.component in Modules/acepglobal/masterlayouts
        $("#theme").attr("href", url);
    }
}
GlobalDataOpsService.ɵfac = function GlobalDataOpsService_Factory(t) { return new (t || GlobalDataOpsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(GlobalDomOpsService), ɵngcc0.ɵɵinject(CommonOperationsService)); };
GlobalDataOpsService.ɵprov = ɵɵdefineInjectable({ factory: function GlobalDataOpsService_Factory() { return new GlobalDataOpsService(ɵɵinject(HttpClient), ɵɵinject(GlobalDomOpsService), ɵɵinject(CommonOperationsService)); }, token: GlobalDataOpsService, providedIn: "root" });
GlobalDataOpsService.ctorParameters = () => [
    { type: HttpClient },
    { type: GlobalDomOpsService },
    { type: CommonOperationsService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GlobalDataOpsService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: GlobalDomOpsService }, { type: CommonOperationsService }]; }, null); })();

// https://github.com/auth0/angular2-jwt/blob/master/src/jwthelper.service.ts
//not using the jwt library and instead used their helper functions so we dont have to depend on another library versioning issue. MB 5/5/2018
function urlBase64Decode(str) {
    let output = str.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
        case 0: {
            break;
        }
        case 2: {
            output += '==';
            break;
        }
        case 3: {
            output += '=';
            break;
        }
        default: {
            throw 'Illegal base64url string!';
        }
    }
    return b64DecodeUnicode(output);
}
// credits for decoder goes to https://github.com/atk
function b64decode(str) {
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let output = '';
    str = String(str).replace(/=+$/, '');
    if (str.length % 4 === 1) {
        throw new Error("'atob' failed: The string to be decoded is not correctly encoded.");
    }
    for (
    // initialize result and counters
    let bc = 0, bs, buffer, idx = 0; 
    // get next character
    (buffer = str.charAt(idx++)); 
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer &&
        ((bs = bc % 4 ? bs * 64 + buffer : buffer),
            // and if not first of each 4 characters,
            // convert the first 8 bits to one ascii character
            bc++ % 4)
        ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
        : 0) {
        // try to find character in table (0-63, not found => -1)
        buffer = chars.indexOf(buffer);
    }
    return output;
}
function b64DecodeUnicode(str) {
    return decodeURIComponent(Array.prototype.map
        .call(b64decode(str), (c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(''));
}
function decodeToken(token = tokenGetter()) {
    if (token === null) {
        return null;
    }
    let parts = token.split('.');
    if (parts.length !== 3) {
        throw new Error('The inspected token doesn\'t appear to be a JWT. Check to make sure it has three parts and see https://jwt.io for more.');
    }
    let decoded = urlBase64Decode(parts[1]);
    if (!decoded) {
        throw new Error('Cannot decode the token.');
    }
    return JSON.parse(decoded);
}
function getTokenExpirationDate(token = tokenGetter()) {
    let decoded;
    decoded = decodeToken(token);
    if (!decoded.hasOwnProperty('exp')) {
        return null;
    }
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
}
function isTokenExpired(token = tokenGetter(), offsetSeconds) {
    if (token === null || token === '')
        return true;
    let date = getTokenExpirationDate(token);
    offsetSeconds = offsetSeconds || 0;
    if (date === null) {
        return true;
    }
    return !(date.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
}
function tokenGetter() {
    return null;
}

/*
ACEP SSO Utility Service
Used to Connect to Acep's SSO Page and other SSO Oprations;
Mohan Bonthu 3/7/2017
*/
//const jwtHelper = new JwtHelperService();
class AcepSSOService {
    constructor(http, globaldataops, globaldomops) {
        this.http = http;
        this.globaldataops = globaldataops;
        this.globaldomops = globaldomops;
        //Private 
        this.ninjaapiendpoint = this.globaldataops.ninjaapiendpoint;
        this.context$ = this.http.get(this.ninjaapiendpoint + 'GetContext').pipe(map((res) => this.ApplyContext(res)), share());
        this.loginurl = this.globaldataops.loginurl;
        this.logouturl = this.globaldataops.logouturl;
        this.subject = new Subject();
        this.contactid = '';
        this.acepid = '';
        this.firstname = '';
        this.isacepmember = false;
        this.toolkitauthencoded = '';
        //toolkitauth = '';
        this.defaultAvatar = "https://webapps.acep.org/globalassets/images/defaultavatar.png";
        //this.headers = this.globaldataops.headers;
    }
    //Gets the SSO user's context//
    GetContext() {
        if (this.context) {
            return of(this.context);
        }
        return this.context$;
    }
    ApplyContext(c) {
        //alert('in applycontext');
        // c = c.json();
        c.user = JSON.parse(c.user);
        c.paymentconfiguration = JSON.parse(c.paymentconfig);
        this.acepJWTToken = c.jwt; //Set JWT
        this.context = c;
        this.acepid = c.user.ContactNumber;
        this.contactid = c.user.ContactId;
        this.firstname = c.user.FirstName;
        this.isacepmember = (c.user.IsACEPMember || c.user.IsStaff);
        if (this.context.user.Avatar == '') {
            this.context.user.Avatar = this.defaultAvatar;
        }
        this.toolkitauthencoded = this.context.toolkitauthencoded;
        return this.context;
    }
    ///Used to Send Loggedin username to Login Header on App Component - Start
    sendMessage(message) {
        this.subject.next({ text: message });
    }
    sendObjectMessage(object) {
        this.subject.next({ context: object });
    }
    clearMessage() {
        this.subject.next();
    }
    getMessage() {
        return this.subject.asObservable();
    }
    //Used to Send Loggedin username to Login Header on App Component - End
    CheckAuthorizationOnResponse(error) {
        if (error.status == '401') {
            this.contactid = undefined;
            //Show notification from current app's ui service here : TODO
            //this.notify('Session Expired. You will be redirected to the Login Page', '', 'error');
            alert('Session Expired. You will be redirected to the Login Page');
            this.login();
        }
    }
    GetCurrentJWT() {
        return this.acepJWTToken;
    }
    IsJWTTokenExpired() {
        //this.jwtHelper.decodeToken(token),
        //this.jwtHelper.getTokenExpirationDate(token),
        let _isTokenExpired = isTokenExpired(this.acepJWTToken);
        return _isTokenExpired;
    }
    isUserLoginExpired() {
        let _isUserLoginExpired = (this.contactid == '' || this.contactid == undefined || this.IsJWTTokenExpired());
        return _isUserLoginExpired;
    }
    //Sign in to login page if not logged in
    login() {
        // alert(this.contactid);
        if (this.isUserLoginExpired()) {
            let url = this.loginurl + escape(window.location.href);
            window.location.href = url;
            this.showwait();
            return false;
        }
        return true;
    }
    //logout
    logout() {
        window.location.href = this.logouturl;
    }
    showwait() {
        $(".loader").show();
    }
    hidewait() {
        $(".loader").hide();
    }
}
AcepSSOService.ɵfac = function AcepSSOService_Factory(t) { return new (t || AcepSSOService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(GlobalDataOpsService), ɵngcc0.ɵɵinject(GlobalDomOpsService)); };
AcepSSOService.ɵprov = ɵɵdefineInjectable({ factory: function AcepSSOService_Factory() { return new AcepSSOService(ɵɵinject(HttpClient), ɵɵinject(GlobalDataOpsService), ɵɵinject(GlobalDomOpsService)); }, token: AcepSSOService, providedIn: "root" });
AcepSSOService.ctorParameters = () => [
    { type: HttpClient },
    { type: GlobalDataOpsService },
    { type: GlobalDomOpsService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AcepSSOService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: GlobalDataOpsService }, { type: GlobalDomOpsService }]; }, null); })();

class AuthUserComponent {
    constructor(ssosvc, globaldomops, globaldataops) {
        this.ssosvc = ssosvc;
        this.globaldomops = globaldomops;
        this.globaldataops = globaldataops;
        this.user = '';
        this.usercontext = '';
    }
    ngOnInit() {
        //GREET USER//USE JWT TOKEN oR SOMETHING TO RETRIEVE USER
        this.globaldomops.showwait();
        this.globaldomops.continueToWait = true;
        this.ssosvc.GetContext().subscribe((c) => {
            if (this.ssosvc.isUserLoginExpired()) {
                this.ssosvc.login();
            }
            else {
                this.ssosvc.sendObjectMessage(c.user);
                this.user = c.user;
                this.usercontext = c;
                this.getComponentData();
            }
        }, error => {
        }, () => {
        });
    }
    getComponentData(initValidationsPlugin = true) {
        //this.globaldomops.initPlugins(initValidationsPlugin);
    }
}
AuthUserComponent.ɵfac = function AuthUserComponent_Factory(t) { return new (t || AuthUserComponent)(ɵngcc0.ɵɵdirectiveInject(AcepSSOService), ɵngcc0.ɵɵdirectiveInject(GlobalDomOpsService), ɵngcc0.ɵɵdirectiveInject(GlobalDataOpsService)); };
AuthUserComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AuthUserComponent, selectors: [["ng-component"]], decls: 0, vars: 0, template: function AuthUserComponent_Template(rf, ctx) { }, encapsulation: 2 });
AuthUserComponent.ctorParameters = () => [
    { type: AcepSSOService },
    { type: GlobalDomOpsService },
    { type: GlobalDataOpsService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthUserComponent, [{
        type: Component,
        args: [{
                template: ``
            }]
    }], function () { return [{ type: AcepSSOService }, { type: GlobalDomOpsService }, { type: GlobalDataOpsService }]; }, null); })();

class LoginInterfaceHeaderComponent {
    constructor(ssosvc, globaldomops, globaldataops) {
        this.ssosvc = ssosvc;
        this.globaldomops = globaldomops;
        this.globaldataops = globaldataops;
        // @Input()
        this.user = '';
        this.ORG = this.globaldataops.ORG;
        this.defaultavatar = '';
        this.showMenu = false;
        this.showSearch = false;
        this.loginheader_env_class = "";
        let loginHeaderSubscription = this.ssosvc.getMessage().subscribe(message => {
            // this.username = message.context.FirstName;
            // this.avatar = message.context.Avatar;
            this.user = this.ssosvc.context ? this.ssosvc.context.user : '';
            //this.loginheader.user = this.user;
        });
    }
    ngOnInit() {
        this.defaultavatar = this.ssosvc.defaultAvatar;
        this.globaldomops.initStylesForLoginHeader();
        this.refreshLoginHeaderEnv();
        this.showSearch = false;
        this.showMenu = false;
        let $this = this;
        $(document).find('div').not('.search').not('.member').click(function (e) {
            if (e.target.id !== 'searchMembership' && e.target.id !== 'memberSearchbtn') {
                e.stopPropagation();
                if ($this.showMenu === true) {
                    $this.showMenu = false;
                    $('.member .menu').slideUp();
                }
                if ($this.showSearch === true) {
                    $this.showSearch = false;
                    $('.search .menu').animate({ width: 'toggle' }, 100);
                }
            }
        });
    }
    login() {
        this.ssosvc.login();
    }
    logout() {
        this.globaldomops.showwait();
        this.ssosvc.logout();
    }
    goToMyAccount() {
        window.location.href = `${this.globaldataops.BasePath}/membership/dashboard?org=${this.ORG}`;
    }
    search(searchtext) {
        window.location.href = 'https://www.acep.org/search.aspx?searchtext=' + searchtext;
        return false;
    }
    toggleMemberMenu(e) {
        e.stopPropagation();
        if (this.showSearch === true) {
            this.showSearch = false;
            $('.search .menu').animate({ width: 'toggle' }, 200);
        }
        if (this.showMenu === false) {
            this.showMenu = true;
            $('.member .menu').slideDown();
        }
        else {
            this.showMenu = false;
            $('.member .menu').slideUp();
        }
    }
    toggleSearchMenu(e) {
        e.stopPropagation();
        if (this.showMenu === true) {
            this.showMenu = false;
            $('.member .menu').slideUp();
        }
        if (this.showSearch === false) {
            this.showSearch = true;
            $('.search .menu').animate({ width: 'toggle' }, 200);
        }
        else {
            this.showSearch = false;
            $('.search .menu').animate({ width: 'toggle' }, 200);
        }
    }
    refreshLoginHeaderEnv() {
        let currentEnv = this.globaldataops.CurrentEnv;
        this.loginheader_env_class = this.ORG + `_styles` + ` headerchange` + Environment[currentEnv].toString().toLocaleLowerCase();
    }
}
LoginInterfaceHeaderComponent.ɵfac = function LoginInterfaceHeaderComponent_Factory(t) { return new (t || LoginInterfaceHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(AcepSSOService), ɵngcc0.ɵɵdirectiveInject(GlobalDomOpsService), ɵngcc0.ɵɵdirectiveInject(GlobalDataOpsService)); };
LoginInterfaceHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LoginInterfaceHeaderComponent, selectors: [["app-login-header-interface"]], ngContentSelectors: _c0, decls: 30, vars: 11, consts: [["role", "navigation"], [1, "container"], [1, "row"], [1, "col-lg-3", "col-md-3", "col-sm-3", "col-xs-6"], [1, "navbar-header"], [1, "navbar-brand", 3, "href"], [1, "brand-logo"], ["alt", "App Logo", 1, "img-responsive", 3, "src"], [1, "col-lg-6", "col-md-6", "col-sm-6", "col-xs-6"], [1, "col-lg-3", "col-md-3", "col-sm-3", "col-xs-12"], ["id", "login-header"], [1, "member", 3, "click"], [1, "avatar"], ["aria-hidden", "true", 1, "fa", "fa-chevron-down", 3, "click"], ["alt", "member image", 3, "src", "click"], [1, "member-name"], [1, "menu"], [1, "user-menu", 3, "ngSwitch"], ["href", "#", 3, "click", 4, "ngSwitchCase"], [3, "click", 4, "ngSwitchCase"], [1, "search"], ["aria-hidden", "true", 1, "fa", "fa-search", "fa-2x", 3, "click"], [1, "search-input"], ["id", "searchMembership", "name", "searchMembership", "placeholder", "Search Here", "type", "text", 1, "memberSearch", 3, "keyup.enter"], ["searchtext", ""], ["id", "memberSearchbtn", "aria-hidden", "true", 1, "fa", "fa-search", "memberSearchbtn", 3, "click"], ["href", "#", 3, "click"], [3, "click"]], template: function LoginInterfaceHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        const _r10 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "a", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵelement(7, "img", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 8);
        ɵngcc0.ɵɵprojection(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 9);
        ɵngcc0.ɵɵelementStart(11, "div", 10);
        ɵngcc0.ɵɵelementStart(12, "div", 11);
        ɵngcc0.ɵɵlistener("click", function LoginInterfaceHeaderComponent_Template_div_click_12_listener($event) { return ctx.toggleMemberMenu($event); });
        ɵngcc0.ɵɵelementStart(13, "div", 12);
        ɵngcc0.ɵɵelementStart(14, "i", 13);
        ɵngcc0.ɵɵlistener("click", function LoginInterfaceHeaderComponent_Template_i_click_14_listener($event) { return ctx.toggleMemberMenu($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "img", 14);
        ɵngcc0.ɵɵlistener("click", function LoginInterfaceHeaderComponent_Template_img_click_15_listener($event) { return ctx.toggleMemberMenu($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 15);
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 16);
        ɵngcc0.ɵɵelementStart(19, "span", 17);
        ɵngcc0.ɵɵtemplate(20, LoginInterfaceHeaderComponent_a_20_Template, 2, 0, "a", 18);
        ɵngcc0.ɵɵtemplate(21, LoginInterfaceHeaderComponent_a_21_Template, 2, 0, "a", 18);
        ɵngcc0.ɵɵtemplate(22, LoginInterfaceHeaderComponent_a_22_Template, 2, 0, "a", 19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 20);
        ɵngcc0.ɵɵelementStart(24, "i", 21);
        ɵngcc0.ɵɵlistener("click", function LoginInterfaceHeaderComponent_Template_i_click_24_listener($event) { return ctx.toggleSearchMenu($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "div", 16);
        ɵngcc0.ɵɵelementStart(26, "div", 22);
        ɵngcc0.ɵɵelementStart(27, "input", 23, 24);
        ɵngcc0.ɵɵlistener("keyup.enter", function LoginInterfaceHeaderComponent_Template_input_keyup_enter_27_listener() { ɵngcc0.ɵɵrestoreView(_r10); const _r3 = ɵngcc0.ɵɵreference(28); return ctx.search(_r3.value); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "i", 25);
        ɵngcc0.ɵɵlistener("click", function LoginInterfaceHeaderComponent_Template_i_click_29_listener() { ɵngcc0.ɵɵrestoreView(_r10); const _r3 = ɵngcc0.ɵɵreference(28); return ctx.search(_r3.value); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("navbar topnavbar ", ctx.loginheader_env_class, " lh");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵpropertyInterpolate1("href", "https://www.", ctx.ORG, ".org", ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate1("src", "https://webapps.acep.org/globalstyles/images/", ctx.ORG, "-logo.png", ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.user == "" ? ctx.defaultavatar : ctx.user == null ? null : ctx.user.Avatar, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" Hi ", ctx.user == "" ? "Guest" : ctx.user.FirstName, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.user == "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", false);
    } }, directives: [ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase], encapsulation: 2 });
LoginInterfaceHeaderComponent.ctorParameters = () => [
    { type: AcepSSOService },
    { type: GlobalDomOpsService },
    { type: GlobalDataOpsService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoginInterfaceHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'app-login-header-interface',
                template: "<!-- START Top Navbar-->\r\n<nav class=\"navbar topnavbar {{loginheader_env_class}} lh\" role=\"navigation\" >\r\n\t<!-- START navbar header-->\r\n\t<div class=\"container\">\r\n\t\t<div class=\"row\">\r\n\t\t\t<div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-6\">\r\n\t\t\t\t<div class=\"navbar-header\">\r\n\t\t\t\t\t<a class=\"navbar-brand\" href=\"https://www.{{ORG}}.org\">\r\n\t\t\t\t\t\t<div class=\"brand-logo\">\r\n\t\t\t\t\t\t\t<img class=\"img-responsive\" src=\"https://webapps.acep.org/globalstyles/images/{{ORG}}-logo.png\" alt=\"App Logo\" />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</a>\r\n\r\n\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\r\n\t\t\t\t<ng-content></ng-content>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12\">\r\n\t\t\t\t<div id=\"login-header\">\r\n\t\t\t\t\t<div class=\"member\" (click)=\"toggleMemberMenu($event)\">\r\n\t\t\t\t\t\t<div class=\"avatar\">\r\n\t\t\t\t\t\t\t<i class=\"fa fa-chevron-down\" aria-hidden=\"true\" (click)=\"toggleMemberMenu($event)\"></i>\r\n\t\t\t\t\t\t\t<img src=\"{{user == '' ? defaultavatar : user?.Avatar}}\" alt=\"member image\" (click)=\"toggleMemberMenu($event)\" />\r\n\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"member-name\">\r\n\t\t\t\t\t\t\tHi {{user == '' ? 'Guest' : user.FirstName}}\r\n\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t<div class=\"menu\">\r\n\t\t\t\t\t\t\t<span class=\"user-menu\" [ngSwitch]=\"user == ''\">\r\n\t\t\t\t\t\t\t\t<a *ngSwitchCase=\"true\" href=\"#\" (click)=\"login()\">Login</a>\r\n\t\t\t\t\t\t\t\t <a *ngSwitchCase=\"false\" href=\"#\" (click)=\"goToMyAccount()\">My Account</a>\r\n\t\t\t\t\t\t\t\t<a *ngSwitchCase=\"false\"  (click)=\"logout()\">Logout</a>\r\n                            </span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"search\">\r\n\t\t\t\t\t\t<i class=\"fa fa-search fa-2x\" aria-hidden=\"true\" (click)=\"toggleSearchMenu($event)\"></i>\r\n\t\t\t\t\t\t<div class=\"menu\">\r\n\t\t\t\t\t\t\t<div class=\"search-input\">\r\n\t\t\t\t\t\t\t\t<input #searchtext class=\"memberSearch\" id=\"searchMembership\" name=\"searchMembership\" placeholder=\"Search Here\" type=\"text\"\r\n\t\t\t\t\t\t\t\t (keyup.enter)=\"search(searchtext.value)\">\r\n\t\t\t\t\t\t\t\t<i class=\"fa fa-search memberSearchbtn\" id=\"memberSearchbtn\" aria-hidden=\"true\" (click)=\"search(searchtext.value)\"></i>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\t<!-- END navbar header-->\r\n</nav>\r\n<!-- END Top Navbar-->\r\n"
            }]
    }], function () { return [{ type: AcepSSOService }, { type: GlobalDomOpsService }, { type: GlobalDataOpsService }]; }, null); })();

class LoginHeaderComponent extends LoginInterfaceHeaderComponent {
}
LoginHeaderComponent.ɵfac = function LoginHeaderComponent_Factory(t) { return ɵLoginHeaderComponent_BaseFactory(t || LoginHeaderComponent); };
LoginHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LoginHeaderComponent, selectors: [["app-login-header"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 30, vars: 11, consts: [["role", "navigation"], [1, "container"], [1, "row"], [1, "col-lg-3", "col-md-3", "col-sm-3", "col-xs-6"], [1, "navbar-header"], [1, "navbar-brand", 3, "href"], [1, "brand-logo"], ["alt", "App Logo", 1, "img-responsive", 3, "src"], [1, "col-lg-6", "col-md-6", "col-sm-6", "col-xs-6"], [1, "col-lg-3", "col-md-3", "col-sm-3", "col-xs-12"], ["id", "login-header"], [1, "member", 3, "click"], [1, "avatar"], ["aria-hidden", "true", 1, "fa", "fa-chevron-down", 3, "click"], ["alt", "member image", 3, "src", "click"], [1, "member-name"], [1, "menu"], [1, "user-menu", 3, "ngSwitch"], ["href", "#", 3, "click", 4, "ngSwitchCase"], [3, "click", 4, "ngSwitchCase"], [1, "search"], ["aria-hidden", "true", 1, "fa", "fa-search", "fa-2x", 3, "click"], [1, "search-input"], ["id", "searchMembership", "name", "searchMembership", "placeholder", "Search Here", "type", "text", 1, "memberSearch", 3, "keyup.enter"], ["searchtext", ""], ["id", "memberSearchbtn", "aria-hidden", "true", 1, "fa", "fa-search", "memberSearchbtn", 3, "click"], ["href", "#", 3, "click"], [3, "click"]], template: function LoginHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        const _r10 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "a", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵelement(7, "img", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 8);
        ɵngcc0.ɵɵprojection(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 9);
        ɵngcc0.ɵɵelementStart(11, "div", 10);
        ɵngcc0.ɵɵelementStart(12, "div", 11);
        ɵngcc0.ɵɵlistener("click", function LoginHeaderComponent_Template_div_click_12_listener($event) { return ctx.toggleMemberMenu($event); });
        ɵngcc0.ɵɵelementStart(13, "div", 12);
        ɵngcc0.ɵɵelementStart(14, "i", 13);
        ɵngcc0.ɵɵlistener("click", function LoginHeaderComponent_Template_i_click_14_listener($event) { return ctx.toggleMemberMenu($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "img", 14);
        ɵngcc0.ɵɵlistener("click", function LoginHeaderComponent_Template_img_click_15_listener($event) { return ctx.toggleMemberMenu($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 15);
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 16);
        ɵngcc0.ɵɵelementStart(19, "span", 17);
        ɵngcc0.ɵɵtemplate(20, LoginHeaderComponent_a_20_Template, 2, 0, "a", 18);
        ɵngcc0.ɵɵtemplate(21, LoginHeaderComponent_a_21_Template, 2, 0, "a", 18);
        ɵngcc0.ɵɵtemplate(22, LoginHeaderComponent_a_22_Template, 2, 0, "a", 19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 20);
        ɵngcc0.ɵɵelementStart(24, "i", 21);
        ɵngcc0.ɵɵlistener("click", function LoginHeaderComponent_Template_i_click_24_listener($event) { return ctx.toggleSearchMenu($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "div", 16);
        ɵngcc0.ɵɵelementStart(26, "div", 22);
        ɵngcc0.ɵɵelementStart(27, "input", 23, 24);
        ɵngcc0.ɵɵlistener("keyup.enter", function LoginHeaderComponent_Template_input_keyup_enter_27_listener() { ɵngcc0.ɵɵrestoreView(_r10); const _r3 = ɵngcc0.ɵɵreference(28); return ctx.search(_r3.value); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "i", 25);
        ɵngcc0.ɵɵlistener("click", function LoginHeaderComponent_Template_i_click_29_listener() { ɵngcc0.ɵɵrestoreView(_r10); const _r3 = ɵngcc0.ɵɵreference(28); return ctx.search(_r3.value); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("navbar topnavbar ", ctx.loginheader_env_class, " lh");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵpropertyInterpolate1("href", "https://www.", ctx.ORG, ".org", ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate1("src", "https://webapps.acep.org/globalstyles/images/", ctx.ORG, "-logo.png", ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.user == "" ? ctx.defaultavatar : ctx.user == null ? null : ctx.user.Avatar, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" Hi ", ctx.user == "" ? "Guest" : ctx.user.FirstName, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.user == "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", false);
    } }, directives: [ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase], encapsulation: 2 });
const ɵLoginHeaderComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(LoginHeaderComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoginHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'app-login-header',
                template: "<!-- START Top Navbar-->\r\n<nav class=\"navbar topnavbar {{loginheader_env_class}} lh\" role=\"navigation\" >\r\n\t<!-- START navbar header-->\r\n\t<div class=\"container\">\r\n\t\t<div class=\"row\">\r\n\t\t\t<div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-6\">\r\n\t\t\t\t<div class=\"navbar-header\">\r\n\t\t\t\t\t<a class=\"navbar-brand\" href=\"https://www.{{ORG}}.org\">\r\n\t\t\t\t\t\t<div class=\"brand-logo\">\r\n\t\t\t\t\t\t\t<img class=\"img-responsive\" src=\"https://webapps.acep.org/globalstyles/images/{{ORG}}-logo.png\" alt=\"App Logo\" />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</a>\r\n\r\n\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\r\n\t\t\t\t<ng-content></ng-content>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12\">\r\n\t\t\t\t<div id=\"login-header\">\r\n\t\t\t\t\t<div class=\"member\" (click)=\"toggleMemberMenu($event)\">\r\n\t\t\t\t\t\t<div class=\"avatar\">\r\n\t\t\t\t\t\t\t<i class=\"fa fa-chevron-down\" aria-hidden=\"true\" (click)=\"toggleMemberMenu($event)\"></i>\r\n\t\t\t\t\t\t\t<img src=\"{{user == '' ? defaultavatar : user?.Avatar}}\" alt=\"member image\" (click)=\"toggleMemberMenu($event)\" />\r\n\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"member-name\">\r\n\t\t\t\t\t\t\tHi {{user == '' ? 'Guest' : user.FirstName}}\r\n\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t<div class=\"menu\">\r\n\t\t\t\t\t\t\t<span class=\"user-menu\" [ngSwitch]=\"user == ''\">\r\n\t\t\t\t\t\t\t\t<a *ngSwitchCase=\"true\" href=\"#\" (click)=\"login()\">Login</a>\r\n\t\t\t\t\t\t\t\t <a *ngSwitchCase=\"false\" href=\"#\" (click)=\"goToMyAccount()\">My Account</a>\r\n\t\t\t\t\t\t\t\t<a *ngSwitchCase=\"false\"  (click)=\"logout()\">Logout</a>\r\n                            </span>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"search\">\r\n\t\t\t\t\t\t<i class=\"fa fa-search fa-2x\" aria-hidden=\"true\" (click)=\"toggleSearchMenu($event)\"></i>\r\n\t\t\t\t\t\t<div class=\"menu\">\r\n\t\t\t\t\t\t\t<div class=\"search-input\">\r\n\t\t\t\t\t\t\t\t<input #searchtext class=\"memberSearch\" id=\"searchMembership\" name=\"searchMembership\" placeholder=\"Search Here\" type=\"text\"\r\n\t\t\t\t\t\t\t\t (keyup.enter)=\"search(searchtext.value)\">\r\n\t\t\t\t\t\t\t\t<i class=\"fa fa-search memberSearchbtn\" id=\"memberSearchbtn\" aria-hidden=\"true\" (click)=\"search(searchtext.value)\"></i>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\t<!-- END navbar header-->\r\n</nav>\r\n<!-- END Top Navbar-->\r\n"
            }]
    }], null, null); })();

class LoginHeaderNonBsComponent extends LoginInterfaceHeaderComponent {
}
LoginHeaderNonBsComponent.ɵfac = function LoginHeaderNonBsComponent_Factory(t) { return ɵLoginHeaderNonBsComponent_BaseFactory(t || LoginHeaderNonBsComponent); };
LoginHeaderNonBsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LoginHeaderNonBsComponent, selectors: [["app-login-header-non-bs"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 19, vars: 9, consts: [["id", "headerwrap"], ["id", "header", 1, "clear"], ["id", "header-l"], [3, "href"], ["id", "header-identityWrap"], ["title", "View Menu", 1, "identityTool", "loginTool"], [1, "identityWrap-image"], ["alt", "member image", 3, "src"], [1, "identityTool-menu"], [1, "identityToolopen", "searchToolopen"], ["type", "text", "id", "searchMembership", "name", "searchMembership", "placeholder", "Search Here", 1, "memberSearch"], ["searchtext", ""], ["type", "submit", "title", "Search", 1, "memberSearchbtn", 3, "click"], [1, "identityToolopen", "loginToolopen", 3, "ngSwitch"], [4, "ngSwitchCase"], [3, "click", 4, "ngSwitchCase"], ["href", "../../membership/dashboard"], [3, "click"]], template: function LoginHeaderNonBsComponent_Template(rf, ctx) { if (rf & 1) {
        const _r7 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "a", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "span", 5);
        ɵngcc0.ɵɵelementStart(7, "p");
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 6);
        ɵngcc0.ɵɵelement(10, "img", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵelementStart(12, "div", 9);
        ɵngcc0.ɵɵelement(13, "input", 10, 11);
        ɵngcc0.ɵɵelementStart(15, "input", 12);
        ɵngcc0.ɵɵlistener("click", function LoginHeaderNonBsComponent_Template_input_click_15_listener() { ɵngcc0.ɵɵrestoreView(_r7); const _r0 = ɵngcc0.ɵɵreference(14); return ctx.search(_r0.value); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 13);
        ɵngcc0.ɵɵtemplate(17, LoginHeaderNonBsComponent_div_17_Template, 5, 0, "div", 14);
        ɵngcc0.ɵɵtemplate(18, LoginHeaderNonBsComponent_a_18_Template, 2, 0, "a", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.ORG);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate1("href", "https://www.", ctx.ORG, ".org", ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1("Hi ", ctx.user == "" ? "Guest" : ctx.user.FirstName, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.user == "" ? ctx.defaultavatar : ctx.user == null ? null : ctx.user.Avatar, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.user == "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", true);
    } }, directives: [ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase], encapsulation: 2 });
const ɵLoginHeaderNonBsComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(LoginHeaderNonBsComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoginHeaderNonBsComponent, [{
        type: Component,
        args: [{
                selector: 'app-login-header-non-bs',
                template: "\r\n<div id=\"headerwrap\" class=\"{{ORG}}\">\r\n  <div id=\"header\" class=\"clear\">\r\n    <!-- header left -->\r\n    <div id=\"header-l\">\r\n      <a href=\"https://www.{{ORG}}.org\">\r\n        <!-- acep logo -->\r\n      </a>\r\n    </div>\r\n    <!-- /header left -->\r\n\r\n    <!-- Subbranding transclusion -->\r\n    <ng-content></ng-content>\r\n    <!-- <div class=\"header-subbrand\" href=\"https://www.acep.org/equal\"> \r\n      <a href=\"http://www.acep.org/equal\">      \r\n      <img class=\"img-responsive\" src=\"https://webapps.acep.org/_images/logos/Logo_CUAP_white_h60.png\" alt=\"App Logo\" />       \r\n      </a>  \r\n    </div> -->\r\n\r\n    <!-- header right -->\r\n    <div id=\"header-identityWrap\">      \r\n      <!--<a class=\"identityTool mSearch\" title=\"Search Here\">Search</a>-->\r\n      <span class=\"identityTool loginTool\" title=\"View Menu\">                \r\n                <p>Hi {{user == '' ? 'Guest' : user.FirstName}}</p>\r\n               \r\n        <div class=\"identityWrap-image\" >\r\n          <img src=\"{{user == '' ? defaultavatar : user?.Avatar}}\" alt=\"member image\" />\r\n        </div>\r\n        </span>\r\n      <!-- member drop menu and search -->\r\n      <div class=\"identityTool-menu\">\r\n        <!-- search -->\r\n        <div class=\"identityToolopen searchToolopen\">\r\n          <input #searchtext type=\"text\" class=\"memberSearch\" id=\"searchMembership\" name=\"searchMembership\" placeholder=\"Search Here\" />          <input type=\"submit\" class=\"memberSearchbtn\" title=\"Search\" (click)=\"search(searchtext.value)\" />\r\n        </div>\r\n        <!-- /search -->\r\n        <!-- member menu -->\r\n        <div class=\"identityToolopen loginToolopen\" [ngSwitch]=\"user == ''\">\r\n          <div *ngSwitchCase=\"false\">\r\n          <a href=\"../../membership/dashboard\" >My Account</a>\r\n          <!--<a href=\"_MemberOverview-01.html\">My Dashboard</a>-->\r\n          <a (click)=\"logout()\">Logout</a>\r\n          </div>\r\n          <a  *ngSwitchCase=\"true\" (click)=\"login()\">Login</a>\r\n        </div>\r\n        <!-- /member menu -->\r\n      </div>\r\n      <!-- member drop menu and search -->\r\n    </div>\r\n    <!-- /header right -->\r\n  </div>\r\n</div>"
            }]
    }], null, null); })();

class LoginHeaderFluidComponent extends LoginInterfaceHeaderComponent {
}
LoginHeaderFluidComponent.ɵfac = function LoginHeaderFluidComponent_Factory(t) { return ɵLoginHeaderFluidComponent_BaseFactory(t || LoginHeaderFluidComponent); };
LoginHeaderFluidComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LoginHeaderFluidComponent, selectors: [["app-login-header-fluid"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 24, vars: 12, consts: [["role", "navigation"], [1, "container-fluid"], [1, "d-flex", "flex-fill"], [1, "flex-fill", "d-inline-flex", "logosection"], [1, "navbar-header", "d-inline-flex", "align-self-center", "flex-fill"], [1, "navbar-brand", 3, "href"], [1, "brand-logo"], ["class", "logo", "alt", "App Logo", 3, "src", 4, "ngIf"], ["class", "img-responsive", "alt", "App Logo", 3, "src", 4, "ngIf"], [1, "sitename", "d-inline-flex", "pl-3", "align-self-center", "align-items-center"], [1, "flex-fill", "d-inline-flex", "align-items-center", "align-content-center"], ["id", "login-header", 1, "d-inline-flex", "align-content-center", "align-items-center", "justify-content-end", "flex-fill"], [1, "member", "d-inline-flex", "align-items-center", "align-content-center", 3, "click"], [1, "member-name", "d-inline-flex", "align-items-center"], [1, "menu"], [1, "user-menu", 3, "ngSwitch"], ["href", "#", 3, "click", 4, "ngSwitchCase"], [3, "click", 4, "ngSwitchCase"], [1, "avatar", "d-inline-flex", "align-items-center"], ["aria-hidden", "true", 1, "fa", "fa-chevron-down", 3, "click"], ["alt", "member image", 3, "src", "click"], ["alt", "App Logo", 1, "logo", 3, "src"], ["alt", "App Logo", 1, "img-responsive", 3, "src"], ["href", "#", 3, "click"], [3, "click"]], template: function LoginHeaderFluidComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "a", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵtemplate(7, LoginHeaderFluidComponent_img_7_Template, 1, 1, "img", 7);
        ɵngcc0.ɵɵtemplate(8, LoginHeaderFluidComponent_img_8_Template, 1, 1, "img", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 9);
        ɵngcc0.ɵɵprojection(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 10);
        ɵngcc0.ɵɵelementStart(12, "div", 11);
        ɵngcc0.ɵɵelementStart(13, "div", 12);
        ɵngcc0.ɵɵlistener("click", function LoginHeaderFluidComponent_Template_div_click_13_listener($event) { return ctx.toggleMemberMenu($event); });
        ɵngcc0.ɵɵelementStart(14, "div", 13);
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 14);
        ɵngcc0.ɵɵelementStart(17, "span", 15);
        ɵngcc0.ɵɵtemplate(18, LoginHeaderFluidComponent_a_18_Template, 2, 0, "a", 16);
        ɵngcc0.ɵɵtemplate(19, LoginHeaderFluidComponent_a_19_Template, 2, 0, "a", 16);
        ɵngcc0.ɵɵtemplate(20, LoginHeaderFluidComponent_a_20_Template, 2, 0, "a", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 18);
        ɵngcc0.ɵɵelementStart(22, "i", 19);
        ɵngcc0.ɵɵlistener("click", function LoginHeaderFluidComponent_Template_i_click_22_listener($event) { return ctx.toggleMemberMenu($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "img", 20);
        ɵngcc0.ɵɵlistener("click", function LoginHeaderFluidComponent_Template_img_click_23_listener($event) { return ctx.toggleMemberMenu($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("navbar topnavbar ", ctx.loginheader_env_class, " lhf");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵpropertyInterpolate1("href", "https://www.", ctx.ORG, ".org", ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ORG == "ACEP");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ORG != "ACEP");
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate1(" Hi ", ctx.user == "" ? "Guest" : ctx.user.FirstName, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.user == "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", false);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.user == "" ? ctx.defaultavatar : ctx.user == null ? null : ctx.user.Avatar, ɵngcc0.ɵɵsanitizeUrl);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase], encapsulation: 2 });
const ɵLoginHeaderFluidComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(LoginHeaderFluidComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LoginHeaderFluidComponent, [{
        type: Component,
        args: [{
                selector: 'app-login-header-fluid',
                template: "<!-- START Top Navbar-->\r\n<nav class=\"navbar topnavbar {{loginheader_env_class}} lhf\" role=\"navigation\">\r\n\t<!-- START navbar header-->\r\n\t<div class=\"container-fluid\">\r\n\t\t<div class=\"d-flex flex-fill\">\r\n\t\t\t<div class=\"flex-fill d-inline-flex logosection\">\r\n\t\t\t\t<div class=\"navbar-header d-inline-flex align-self-center flex-fill\">\r\n\t\t\t\t\t<a class=\"navbar-brand\" href=\"https://www.{{ORG}}.org\">\r\n\t\t\t\t\t\t<div class=\"brand-logo\">\r\n              <img *ngIf=\"ORG == 'ACEP'\" class=\"logo\" src=\"https://webapps.acep.org/globalstyles/images/{{ORG}}_logo.svg\" alt=\"App Logo\" />\r\n\t\t\t\t\t\t\t<img *ngIf=\"ORG != 'ACEP'\" class=\"img-responsive\" src=\"https://webapps.acep.org/globalstyles/images/{{ORG}}-logo.png\" alt=\"App Logo\" />\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</a>\r\n\t\t\t\t\t<div class=\"sitename d-inline-flex pl-3  align-self-center align-items-center\">\r\n\t\t\t\t\t\t<ng-content></ng-content>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\r\n\t\t\t<div class=\"flex-fill d-inline-flex align-items-center align-content-center\">\r\n\t\t\t\t<div id=\"login-header\" class=\"d-inline-flex align-content-center align-items-center justify-content-end flex-fill\">\r\n\t\t\t\t\t<div class=\"member d-inline-flex align-items-center align-content-center\" (click)=\"toggleMemberMenu($event)\">\r\n            <div class=\"member-name d-inline-flex align-items-center\">\r\n\t\t\t\t\t\t\tHi {{user == '' ? 'Guest' : user.FirstName}}\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t<div class=\"menu\">\r\n\t\t\t\t\t\t\t<span class=\"user-menu\" [ngSwitch]=\"user == ''\">\r\n\t\t\t\t\t\t\t\t<a *ngSwitchCase=\"true\" href=\"#\" (click)=\"login()\">Login</a>\r\n\t\t\t\t\t\t\t\t<a *ngSwitchCase=\"false\" href=\"#\" (click)=\"goToMyAccount()\">My Account</a>\r\n\t\t\t\t\t\t\t\t<a *ngSwitchCase=\"false\" (click)=\"logout()\">Logout</a>\r\n\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t</div>\r\n            <div class=\"avatar d-inline-flex align-items-center\">\r\n\t\t\t\t\t\t\t<i class=\"fa fa-chevron-down\" aria-hidden=\"true\" (click)=\"toggleMemberMenu($event)\"></i>\r\n\t\t\t\t\t\t\t<img src=\"{{user == '' ? defaultavatar : user?.Avatar}}\" alt=\"member image\" (click)=\"toggleMemberMenu($event)\" />\r\n\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<!-- <div class=\"search\">\r\n\t\t\t\t\t\t<i class=\"fa fa-search fa-2x\" aria-hidden=\"true\" (click)=\"toggleSearchMenu($event)\"></i>\r\n\t\t\t\t\t\t<div class=\"menu\">\r\n\t\t\t\t\t\t\t<div class=\"search-input\">\r\n\t\t\t\t\t\t\t\t<input #searchtext class=\"memberSearch\" id=\"searchMembership\" name=\"searchMembership\" placeholder=\"Search Here\" type=\"text\" (keyup.enter)=\"search(searchtext.value)\">\r\n\t\t\t\t\t\t\t\t<i class=\"fa fa-search memberSearchbtn\" id=\"memberSearchbtn\" aria-hidden=\"true\" (click)=\"search(searchtext.value)\"></i>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div> -->\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\t<!-- END navbar header-->\r\n</nav>\r\n<!-- END Top Navbar-->\r\n"
            }]
    }], null, null); })();

class LayoutHostDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
LayoutHostDirective.ɵfac = function LayoutHostDirective_Factory(t) { return new (t || LayoutHostDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
LayoutHostDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: LayoutHostDirective, selectors: [["", "app-layout-host", ""]] });
LayoutHostDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LayoutHostDirective, [{
        type: Directive,
        args: [{
                selector: '[app-layout-host]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();

class LayoutInterfaceComponent {
    constructor(
    // private router: Router,
    // private route: ActivatedRoute,
    globaldomops, globaldataops, ssosvc) {
        //this.globaldomops.showwait();
        // let loginHeaderSubscription: Subscription = this.ssosvc.getMessage().subscribe(message => {
        //   // this.username = message.context.FirstName;
        //   // this.avatar = message.context.Avatar;
        //   this.user = this.ssosvc.context? this.ssosvc.context.user : '';
        //   //this.loginheader.user = this.user;
        // });
        this.globaldomops = globaldomops;
        this.globaldataops = globaldataops;
        this.ssosvc = ssosvc;
        //user: any = '';
        this.routename = '';
        this.subscriptions = [];
        // let routerEventsSubscription: Subscription = this.router.events
        //   .subscribe((event) => {
        //    if (event instanceof NavigationEnd) {
        //       this.routename = this.router.url.replace('/', '');
        //       //GOOGLE ANALYTICS
        //       this.globaldataops.InjectAnalytics(event.urlAfterRedirects);
        //     }
        //   });      
        // //this.subscriptions.push(loginHeaderSubscription);
        // this.subscriptions.push(routerEventsSubscription);
    }
    ngOnInit() {
        //SET THEME.. IS THIS THE RIGHT PLACE??
        // this.globaldataops.initThemesBasedOnORG();
    }
    ngAfterViewInit() {
    }
    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.subscriptions.forEach((subscription) => {
            subscription.unsubscribe();
        });
    }
}
LayoutInterfaceComponent.ɵfac = function LayoutInterfaceComponent_Factory(t) { return new (t || LayoutInterfaceComponent)(ɵngcc0.ɵɵdirectiveInject(GlobalDomOpsService), ɵngcc0.ɵɵdirectiveInject(GlobalDataOpsService), ɵngcc0.ɵɵdirectiveInject(AcepSSOService)); };
LayoutInterfaceComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LayoutInterfaceComponent, selectors: [["app-layout-interface"]], decls: 2, vars: 0, template: function LayoutInterfaceComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, " layout-interface works!\n");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
LayoutInterfaceComponent.ctorParameters = () => [
    { type: GlobalDomOpsService },
    { type: GlobalDataOpsService },
    { type: AcepSSOService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LayoutInterfaceComponent, [{
        type: Component,
        args: [{
                selector: 'app-layout-interface',
                template: "<p>\r\n  layout-interface works!\r\n</p>\r\n"
            }]
    }], function () { return [{ type: GlobalDomOpsService }, { type: GlobalDataOpsService }, { type: AcepSSOService }]; }, null); })();

class LayoutAcepComponent extends LayoutInterfaceComponent {
}
LayoutAcepComponent.ɵfac = function LayoutAcepComponent_Factory(t) { return ɵLayoutAcepComponent_BaseFactory(t || LayoutAcepComponent); };
LayoutAcepComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LayoutAcepComponent, selectors: [["app-layout-acep"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 8, vars: 0, consts: [[1, "wrapper"], [1, "topnavbar-wrapper"], [1, "content-wrapper"], [1, "loader"]], template: function LayoutAcepComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "app-login-header", 1);
        ɵngcc0.ɵɵelementStart(2, "section");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelement(4, "div", 3);
        ɵngcc0.ɵɵelement(5, "router-outlet");
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(7, "app-shared-things");
    } }, directives: function () { return [LoginHeaderComponent, ɵngcc3.RouterOutlet, SharedThingsComponent]; }, encapsulation: 2 });
const ɵLayoutAcepComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(LayoutAcepComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LayoutAcepComponent, [{
        type: Component,
        args: [{
                selector: 'app-layout-acep',
                template: "<div class=\"wrapper\">\r\n  <!-- top navbar-->\r\n  <app-login-header class=\"topnavbar-wrapper\"></app-login-header>\r\n  <section>\r\n    <!-- Page content-->\r\n    <div class=\"content-wrapper\">\r\n      <div class=\"loader\"></div>\r\n        <router-outlet></router-outlet>  \r\n      <ng-content></ng-content>       \r\n    </div>\r\n  </section>\r\n  <!--<footer app-footer></footer>--> \r\n</div>\r\n\r\n\r\n<app-shared-things></app-shared-things>\r\n",
                encapsulation: ViewEncapsulation.None
            }]
    }], null, null); })();

class LayoutEmraComponent extends LayoutInterfaceComponent {
}
LayoutEmraComponent.ɵfac = function LayoutEmraComponent_Factory(t) { return ɵLayoutEmraComponent_BaseFactory(t || LayoutEmraComponent); };
LayoutEmraComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LayoutEmraComponent, selectors: [["app-layout-emra"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 7, vars: 0, consts: [[1, "wrapper"], [1, "topnavbar-wrapper"], [1, "content-wrapper"], [1, "loader"]], template: function LayoutEmraComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "app-login-header", 1);
        ɵngcc0.ɵɵelementStart(2, "section");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelement(4, "div", 3);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(6, "app-shared-things");
    } }, directives: function () { return [LoginHeaderComponent, SharedThingsComponent]; }, encapsulation: 2 });
const ɵLayoutEmraComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(LayoutEmraComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LayoutEmraComponent, [{
        type: Component,
        args: [{
                selector: 'app-layout-emra',
                template: "<div class=\"wrapper\">\r\n  <!-- top navbar-->\r\n  <app-login-header class=\"topnavbar-wrapper\"></app-login-header>\r\n  <section>\r\n    <!-- Page content-->\r\n    <div class=\"content-wrapper\">\r\n      <div class=\"loader\"></div>\r\n      <!-- <router-outlet></router-outlet> -->\r\n      <ng-content></ng-content> \r\n    </div>\r\n  </section>\r\n  <!--<footer app-footer></footer>-->\r\n</div>\r\n\r\n\r\n<app-shared-things></app-shared-things>",
                encapsulation: ViewEncapsulation.None
            }]
    }], null, null); })();

class LayoutSempaComponent extends LayoutInterfaceComponent {
}
LayoutSempaComponent.ɵfac = function LayoutSempaComponent_Factory(t) { return ɵLayoutSempaComponent_BaseFactory(t || LayoutSempaComponent); };
LayoutSempaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LayoutSempaComponent, selectors: [["app-layout-sempa"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 7, vars: 0, consts: [[1, "wrapper"], [1, "topnavbar-wrapper"], [1, "content-wrapper"], [1, "loader"]], template: function LayoutSempaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "app-login-header", 1);
        ɵngcc0.ɵɵelementStart(2, "section");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelement(4, "div", 3);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(6, "app-shared-things");
    } }, directives: function () { return [LoginHeaderComponent, SharedThingsComponent]; }, encapsulation: 2 });
const ɵLayoutSempaComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(LayoutSempaComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LayoutSempaComponent, [{
        type: Component,
        args: [{
                selector: 'app-layout-sempa',
                template: "<div class=\"wrapper\">\r\n  <!-- top navbar-->\r\n  <app-login-header class=\"topnavbar-wrapper\"></app-login-header>\r\n  <section>\r\n    <!-- Page content-->\r\n    <div class=\"content-wrapper\">\r\n      <div class=\"loader\"></div>\r\n      <!-- <router-outlet></router-outlet> -->\r\n      <ng-content></ng-content> \r\n    </div>\r\n  </section>\r\n  <!--<footer app-footer></footer>-->\r\n</div>\r\n\r\n\r\n<app-shared-things></app-shared-things>",
                encapsulation: ViewEncapsulation.None
            }]
    }], null, null); })();

const fadeAnimation = trigger('fadeAnimation', [
    transition('* => *', [
        query(':enter', [style({ opacity: 0 })], { optional: true }),
        query(':leave', [style({ opacity: 1 }), animate('0.3s', style({ opacity: 0 }))], { optional: true }),
        query(':enter', [style({ opacity: 0 }), animate('0.3s', style({ opacity: 1 }))], { optional: true })
    ])
]);

class LayoutMasterFluidComponent extends LayoutInterfaceComponent {
    constructor() {
        super(...arguments);
        this.EnableAnimations = true;
        // constructor() { 
        //   super();
        //  }
        // ngOnInit() {
        // }
    }
}
LayoutMasterFluidComponent.ɵfac = function LayoutMasterFluidComponent_Factory(t) { return ɵLayoutMasterFluidComponent_BaseFactory(t || LayoutMasterFluidComponent); };
LayoutMasterFluidComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LayoutMasterFluidComponent, selectors: [["app-layout-master-fluid"]], inputs: { EnableAnimations: "EnableAnimations" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c2, decls: 12, vars: 1, consts: [[1, "container-fluid", "p-0", "h-100"], [1, "topnavbar-wrapper"], [1, "content-wrapper"], [1, "loader"], ["o", "outlet"]], template: function LayoutMasterFluidComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c1);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "app-login-header-fluid", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "section");
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelement(5, "div", 3);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵprojection(7, 2);
        ɵngcc0.ɵɵelementStart(8, "main");
        ɵngcc0.ɵɵelement(9, "router-outlet", null, 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(11, "app-shared-things");
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(10);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("@fadeAnimation", _r0.isActivated && ctx.EnableAnimations ? _r0.activatedRoute : "");
    } }, directives: function () { return [LoginHeaderFluidComponent, ɵngcc3.RouterOutlet, SharedThingsComponent]; }, encapsulation: 2, data: { animation: [fadeAnimation] } });
LayoutMasterFluidComponent.propDecorators = {
    EnableAnimations: [{ type: Input }]
};
const ɵLayoutMasterFluidComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(LayoutMasterFluidComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LayoutMasterFluidComponent, [{
        type: Component,
        args: [{
                selector: 'app-layout-master-fluid',
                template: "<div class=\"container-fluid p-0 h-100\">\r\n    <!-- top navbar-->\r\n    <app-login-header-fluid class=\"topnavbar-wrapper\">\r\n        <ng-content select=\".header-content\"></ng-content>\r\n    </app-login-header-fluid>\r\n    <section>\r\n        <!-- Page content-->\r\n        <div class=\"content-wrapper\">\r\n            <div class=\"loader\"></div>\r\n            <ng-content select=\".side-nav\"></ng-content>\r\n            <ng-content select=\".body-content\"></ng-content>\r\n            <main [@fadeAnimation]=\"o.isActivated && EnableAnimations ? o.activatedRoute : ''\">\r\n                <router-outlet #o=\"outlet\"></router-outlet>\r\n            </main>\r\n        </div>\r\n    </section>\r\n    <!--<footer app-footer></footer>-->\r\n</div>\r\n\r\n\r\n<app-shared-things></app-shared-things>",
                animations: [fadeAnimation],
                encapsulation: ViewEncapsulation.None
            }]
    }], null, { EnableAnimations: [{
            type: Input
        }] }); })();

class LayoutMasterComponent {
    constructor(globaldomops, globaldataops, ssosvc) {
        this.globaldomops = globaldomops;
        this.globaldataops = globaldataops;
        this.ssosvc = ssosvc;
    }
    ngOnInit() {
    }
}
LayoutMasterComponent.ɵfac = function LayoutMasterComponent_Factory(t) { return new (t || LayoutMasterComponent)(ɵngcc0.ɵɵdirectiveInject(GlobalDomOpsService), ɵngcc0.ɵɵdirectiveInject(GlobalDataOpsService), ɵngcc0.ɵɵdirectiveInject(AcepSSOService)); };
LayoutMasterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LayoutMasterComponent, selectors: [["app-layout-master"]], ngContentSelectors: _c2, decls: 10, vars: 0, consts: [[1, "wrapper"], [1, "topnavbar-wrapper"], [1, "content-wrapper"], [1, "loader"]], template: function LayoutMasterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c1);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "app-login-header", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "section");
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelement(5, "div", 3);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵprojection(7, 2);
        ɵngcc0.ɵɵelement(8, "router-outlet");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(9, "app-shared-things");
    } }, directives: function () { return [LoginHeaderComponent, ɵngcc3.RouterOutlet, SharedThingsComponent]; }, encapsulation: 2 });
LayoutMasterComponent.ctorParameters = () => [
    { type: GlobalDomOpsService },
    { type: GlobalDataOpsService },
    { type: AcepSSOService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LayoutMasterComponent, [{
        type: Component,
        args: [{
                selector: 'app-layout-master',
                template: "<div class=\"wrapper\">\r\n    <!-- top navbar-->\r\n    <app-login-header class=\"topnavbar-wrapper\">\r\n        <ng-content select=\".header-content\"></ng-content>\r\n    </app-login-header>\r\n\r\n    <!-- <app-login-header-non-bs class=\"topnavbar-wrapper\">\r\n                <ng-content select=\".header-content\"></ng-content>           \r\n        </app-login-header-non-bs> -->\r\n    <section>\r\n        <!-- Page content-->\r\n        <div class=\"content-wrapper\">\r\n            <div class=\"loader\"></div>\r\n            <ng-content select=\".side-nav\"></ng-content>\r\n            <ng-content select=\".body-content\"></ng-content>\r\n            <router-outlet></router-outlet>\r\n        </div>\r\n    </section>\r\n    <!--<footer app-footer></footer>-->\r\n</div>\r\n\r\n\r\n<app-shared-things></app-shared-things>"
            }]
    }], function () { return [{ type: GlobalDomOpsService }, { type: GlobalDataOpsService }, { type: AcepSSOService }]; }, null); })();

class LayoutOrgMasterComponent {
    constructor(componentFactoryResolver, globaldomops, globaldataops, ssosvc) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.globaldomops = globaldomops;
        this.globaldataops = globaldataops;
        this.ssosvc = ssosvc;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        this.loadComponent();
    }
    ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.changeDetectorRef.detach();
            //this.componentRef.destroy();
        }
    }
    loadComponent() {
        let component;
        let ORG = this.globaldataops.ORG;
        if (ORG == "EMRA") {
            component = LayoutEmraComponent;
        }
        else if (ORG == "SEMPA") {
            component = LayoutSempaComponent;
        }
        else {
            component = LayoutAcepComponent;
        }
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        let viewContainerRef = this.layoutHost.viewContainerRef;
        viewContainerRef.clear();
        this.componentRef = viewContainerRef.createComponent(componentFactory);
        //(<LayoutInterfaceComponent>componentRef.instance).user = globaldataops.context;
        //  https://stackoverflow.com/questions/42387348/angular2-dynamic-content-loading-throws-expression-changed-exception
        this.componentRef.changeDetectorRef.detectChanges();
    }
}
LayoutOrgMasterComponent.ɵfac = function LayoutOrgMasterComponent_Factory(t) { return new (t || LayoutOrgMasterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(GlobalDomOpsService), ɵngcc0.ɵɵdirectiveInject(GlobalDataOpsService), ɵngcc0.ɵɵdirectiveInject(AcepSSOService)); };
LayoutOrgMasterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LayoutOrgMasterComponent, selectors: [["app-layout-org-master"]], viewQuery: function LayoutOrgMasterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(LayoutHostDirective, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.layoutHost = _t.first);
    } }, decls: 1, vars: 0, consts: [["app-layout-host", ""]], template: function LayoutOrgMasterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, LayoutOrgMasterComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
    } }, directives: [LayoutHostDirective], encapsulation: 2 });
LayoutOrgMasterComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: GlobalDomOpsService },
    { type: GlobalDataOpsService },
    { type: AcepSSOService }
];
LayoutOrgMasterComponent.propDecorators = {
    layoutHost: [{ type: ViewChild, args: [LayoutHostDirective, { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LayoutOrgMasterComponent, [{
        type: Component,
        args: [{
                selector: 'app-layout-org-master',
                template: "  <ng-template app-layout-host></ng-template>"
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: GlobalDomOpsService }, { type: GlobalDataOpsService }, { type: AcepSSOService }]; }, { layoutHost: [{
            type: ViewChild,
            args: [LayoutHostDirective, { static: false }]
        }] }); })();

class SharedThingsComponent {
    constructor(componentFactoryResolver, globaldomops, globaldataops, ssosvc) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.globaldomops = globaldomops;
        this.globaldataops = globaldataops;
        this.ssosvc = ssosvc;
        this.csspath = '';
        this.headercsspath = '';
    }
    ngOnInit() {
        this.csspath = `${this.globaldataops.BasePath}/globalstyles/css/${this.globaldataops.ORG}.css`;
        this.headercsspath = `${this.globaldataops.BasePath}/globalstyles/css/header.css`;
    }
}
SharedThingsComponent.ɵfac = function SharedThingsComponent_Factory(t) { return new (t || SharedThingsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(GlobalDomOpsService), ɵngcc0.ɵɵdirectiveInject(GlobalDataOpsService), ɵngcc0.ɵɵdirectiveInject(AcepSSOService)); };
SharedThingsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SharedThingsComponent, selectors: [["app-shared-things"]], decls: 11, vars: 7, consts: [["rel", "stylesheet", "type", "text/css", 3, "href"], [1, "container", "contactfooter"], [1, "row", "margin-top-100"], [1, "col-lg-12", "pull-left", "center"], [3, "href"]], template: function SharedThingsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "link", 0);
        ɵngcc0.ɵɵpipe(1, "safe");
        ɵngcc0.ɵɵelement(2, "link", 0);
        ɵngcc0.ɵɵpipe(3, "safe");
        ɵngcc0.ɵɵelementStart(4, "div", 1);
        ɵngcc0.ɵɵelementStart(5, "div", 2);
        ɵngcc0.ɵɵelementStart(6, "div", 3);
        ɵngcc0.ɵɵelementStart(7, "p");
        ɵngcc0.ɵɵtext(8, "If you need assistance, please contact our ");
        ɵngcc0.ɵɵelementStart(9, "a", 4);
        ɵngcc0.ɵɵtext(10, "Member and Customer Care");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("href", ɵngcc0.ɵɵpipeBind1(1, 3, ctx.csspath), ɵngcc0.ɵɵsanitizeResourceUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("href", ɵngcc0.ɵɵpipeBind1(3, 5, ctx.headercsspath), ɵngcc0.ɵɵsanitizeResourceUrl);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵpropertyInterpolate1("href", "", ctx.globaldataops.BasePath, "/membership/account/#contactus", ɵngcc0.ɵɵsanitizeUrl);
    } }, pipes: function () { return [SafePipe]; }, encapsulation: 2 });
SharedThingsComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: GlobalDomOpsService },
    { type: GlobalDataOpsService },
    { type: AcepSSOService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SharedThingsComponent, [{
        type: Component,
        args: [{
                selector: 'app-shared-things',
                template: "<!--<p class=\"t1\">\r\n  shared-things, feedback Widget, Analytics etc... works!\r\n</p>-->\r\n\r\n<!-- <link href=\"\" id=\"theme1\" rel=\"stylesheet\" type=\"text/css\"> -->\r\n\r\n<link rel=\"stylesheet\" type=\"text/css\" [href]=\"csspath | safe\">\r\n<link rel=\"stylesheet\" type=\"text/css\" [href]=\"headercsspath | safe\">\r\n\r\n<div class=\"container contactfooter\">\r\n    <div class=\"row margin-top-100\">\r\n        <!--<div class=\"col-lg-2 hide-mobile\"></div>-->\r\n        <div class=\"col-lg-12 pull-left center\">\r\n            <p>If you need assistance, please contact our <a href=\"{{globaldataops.BasePath}}/membership/account/#contactus\">Member and Customer Care</a></p>\r\n        </div>\r\n    </div>\r\n</div>"
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: GlobalDomOpsService }, { type: GlobalDataOpsService }, { type: AcepSSOService }]; }, null); })();

class SafePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
SafePipe.ɵfac = function SafePipe_Factory(t) { return new (t || SafePipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.DomSanitizer)); };
SafePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "safe", type: SafePipe, pure: true });
SafePipe.ctorParameters = () => [
    { type: DomSanitizer }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SafePipe, [{
        type: Pipe,
        args: [{ name: 'safe' }]
    }], function () { return [{ type: ɵngcc4.DomSanitizer }]; }, null); })();
// https://stackoverflow.com/questions/40593347/set-stylesheet-href-dynamicaly-on-a-component-in-angular-2

//  export class AcepGlobalModule { }
class AcepGlobalModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error("AcepGlobalModule is already loaded. Import it in the AppModule only");
        }
    }
    static forRoot() {
        return {
            ngModule: AcepGlobalModule,
            providers: [
            // { provide: HTTP_INTERCEPTORS, useClass: AcepHttpInterceptor, multi: true }
            ]
        };
    }
}
AcepGlobalModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AcepGlobalModule });
AcepGlobalModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AcepGlobalModule_Factory(t) { return new (t || AcepGlobalModule)(ɵngcc0.ɵɵinject(AcepGlobalModule, 12)); }, imports: [[CommonModule, RouterModule]] });
AcepGlobalModule.ctorParameters = () => [
    { type: AcepGlobalModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AcepGlobalModule, { declarations: function () { return [AuthUserComponent, LoginInterfaceHeaderComponent, LoginHeaderComponent, LoginHeaderNonBsComponent, LoginHeaderFluidComponent, LayoutHostDirective, LayoutInterfaceComponent, LayoutMasterFluidComponent, LayoutAcepComponent, LayoutEmraComponent, LayoutSempaComponent, LayoutMasterComponent, LayoutOrgMasterComponent, SharedThingsComponent, SafePipe]; }, imports: function () { return [CommonModule, RouterModule]; }, exports: function () { return [LoginHeaderComponent, LoginHeaderNonBsComponent, LoginHeaderFluidComponent, LayoutMasterComponent, LayoutMasterFluidComponent, LayoutOrgMasterComponent, AuthUserComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AcepGlobalModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, RouterModule],
                declarations: [
                    AuthUserComponent,
                    LoginInterfaceHeaderComponent,
                    LoginHeaderComponent,
                    LoginHeaderNonBsComponent,
                    LoginHeaderFluidComponent,
                    LayoutHostDirective,
                    LayoutInterfaceComponent,
                    LayoutMasterFluidComponent,
                    LayoutAcepComponent,
                    LayoutEmraComponent,
                    LayoutSempaComponent,
                    LayoutMasterComponent,
                    LayoutOrgMasterComponent,
                    SharedThingsComponent,
                    SafePipe
                ],
                exports: [
                    LoginHeaderComponent,
                    LoginHeaderNonBsComponent,
                    LoginHeaderFluidComponent,
                    LayoutMasterComponent,
                    LayoutMasterFluidComponent,
                    LayoutOrgMasterComponent,
                    AuthUserComponent
                ]
            }]
    }], function () { return [{ type: AcepGlobalModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

class AuthGuard {
    constructor(router, ssoSvc) {
        this.router = router;
        this.ssoSvc = ssoSvc;
    }
    canActivate() {
        //this.ssoSvc.showwait();
        return this.ssoSvc.GetContext().pipe(map((c) => {
            if (this.ssoSvc.isUserLoginExpired()) {
                this.ssoSvc.login();
            }
            else {
                //this.ssoSvc.sendMessage(c.user.FirstName);
                this.ssoSvc.sendObjectMessage(c.user);
                return true;
            }
        }), first()); // To make the observable complete after the first emission
    }
}
AuthGuard.ɵfac = function AuthGuard_Factory(t) { return new (t || AuthGuard)(ɵngcc0.ɵɵinject(ɵngcc3.Router), ɵngcc0.ɵɵinject(AcepSSOService)); };
AuthGuard.ɵprov = ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(ɵɵinject(Router), ɵɵinject(AcepSSOService)); }, token: AuthGuard, providedIn: "root" });
AuthGuard.ctorParameters = () => [
    { type: Router },
    { type: AcepSSOService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.Router }, { type: AcepSSOService }]; }, null); })();

class AcepHttpInterceptor {
    constructor(ssoSvc) {
        this.ssoSvc = ssoSvc;
        this.count = 0;
    }
    intercept(req, next) {
        // 1. SHOW SPINNER
        this.count++;
        if (this.count == 1)
            this.ssoSvc.showwait();
        console.info(`Http Interceptor Url`, req.url);
        // 2. H E A D E R S
        let headers = req.headers;
        //if headers are already present do not update
        if (!headers.has('Content-Type')) {
            headers = new HttpHeaders({
                'Authorization': `Bearer ${this.ssoSvc.acepJWTToken}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'PUT, GET, POST',
                'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
            });
        }
        // const headers = req.headers
        //     .set('Content-Type', 'application/json');
        // 3. CHECK JWT AUTHENTICATION
        //if this header is present, then do not check for JWT Authentication OR making call to get JWT
        if (!headers.has("x-noauth") && req.url.toLowerCase().indexOf('getcontext') == -1 && this.ssoSvc.isUserLoginExpired()) {
            this.ssoSvc.login();
            return of(null);
        }
        const authReq = req.clone({ headers });
        let handleObs = next.handle(authReq);
        return handleObs.pipe(catchError((err) => {
            return throwError(err);
        }), tap((event) => {
            if (event instanceof HttpResponse) {
                this.count--;
                // do stuff with response if you want
            }
        }, (err) => {
            if (err instanceof HttpErrorResponse) {
                this.count--;
                if (err.status === 401) {
                    // redirect to the login route
                    // or show a modal
                    this.ssoSvc.login();
                }
                else {
                    if (this.count == 0)
                        this.ssoSvc.hidewait();
                }
            }
        }, () => {
            if (this.count == 0)
                this.ssoSvc.hidewait();
        }));
    }
}
AcepHttpInterceptor.ɵfac = function AcepHttpInterceptor_Factory(t) { return new (t || AcepHttpInterceptor)(ɵngcc0.ɵɵinject(AcepSSOService)); };
AcepHttpInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AcepHttpInterceptor, factory: AcepHttpInterceptor.ɵfac });
AcepHttpInterceptor.ctorParameters = () => [
    { type: AcepSSOService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AcepHttpInterceptor, [{
        type: Injectable
    }], function () { return [{ type: AcepSSOService }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AcepGlobalModule, AcepHttpInterceptor, AcepSSOService, AuthGuard, AuthUserComponent, CommonOperationsService, GlobalDataOpsService, GlobalDomOpsService, LayoutMasterComponent, LoginHeaderComponent, LoginInterfaceHeaderComponent as ɵa, LoginHeaderNonBsComponent as ɵb, LoginHeaderFluidComponent as ɵc, LayoutHostDirective as ɵd, LayoutInterfaceComponent as ɵe, LayoutMasterFluidComponent as ɵf, fadeAnimation as ɵg, LayoutAcepComponent as ɵh, LayoutEmraComponent as ɵi, LayoutSempaComponent as ɵj, LayoutOrgMasterComponent as ɵk, SharedThingsComponent as ɵl, SafePipe as ɵm };

//# sourceMappingURL=acepteam-globalspack.js.map